var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { attrs: { id: "passwordreset--modal" } },
      [
        _c(
          "transition",
          { attrs: { name: "fade", mode: "out-in", duration: 500 } },
          [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("passwordreset-header", {
                  attrs: { "lang-root": "" + _vm.langRoot }
                }),
                _vm._v(" "),
                _c("router-view", { attrs: { "lang-root": "" + _vm.langRoot } })
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61e88caf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61e88caf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./login/Components/PasswordReset.vue
// module id = /1EC
// module chunks = 1